
<footer class="footer-custom py-4 border-top">
  <div class="container-fluid px-4 px-md-5">
    <div class="row align-items-center text-md-start">

      <div class="col-md-4 mb-3 mb-md-0">
        <p class="mb-0 text-muted">© {{currentYear}} FGC - Fundo Garantidor de Créditos</p>
        <p class="mb-0 text-muted">Todos os direitos reservados</p>
      </div>

      <div class="col-md-4 mb-3 mb-md-0">
        <ul class="list-unstyled mb-0 d-flex flex-column align-items-center">
          <li><a target="_blank" href="https://www.fgc.org.br/documents/d/asset-library-52554/politica-de-privacidade-do-fgc-1" class="footer-link">Política de Privacidade</a></li>
        </ul>
      </div>

      <div class="col-md-4 d-flex align-items-center justify-content-center justify-content-md-end">
        <div class="d-flex flex-column align-items-start">
          <p class="text-muted small mb-0"><i class="fas fa-question"></i> FAQ: <a href="https://www.fgc.org.br/faq" target="_blank" class="footer-link">www.fgc.org.br/faq</a></p>
          <p class="text-muted small mb-0"><i class="fas fa-envelope"></i> E-mail: <a href="mailto:atendimento.credores@fgc.org.br" class="footer-link">atendimento.credores@fgc.org.br</a></p>
          <!-- <p class="text-muted small mb-0"><i class="fas fa-comment-alt"></i> Chatbot: <a href="#" class="footer-link">link.chatbot.exemple</a></p> -->
          <p class="text-muted small mb-0"><i class="fas fa-phone"></i> Telefone: <strong>0800 400 5862</strong> das 9h às 18h</p>
        </div>
      </div>

    </div>
  </div>
</footer>
